
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/locale/my-area/register",
      function () {
        return require("private-next-pages/locale/my-area/register.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/locale/my-area/register"])
      });
    }
  